module.exports = __webpack_public_path__ + "static/lunchtype22-medium-webfont-e8b5f983e4a236248f57d02f25a477c9.ttf";